import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { ref, onValue } from "firebase/database";
import { processTaskLogic } from './GrabbingOrder';
import { useTranslation } from 'react-i18next'; // i18n hook imported
import Swal from 'sweetalert2';
import './Record.css';

const Record = ({ currentUser }) => {
  const { t } = useTranslation(); // Translation function initialized
  const [tasks, setTasks] = useState([]);
  const [activeTab, setActiveTab] = useState('pending');
  const [userData, setUserData] = useState(currentUser);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) return;

    // Real-time user data for balance check
    const userRef = ref(db, `users/${currentUser.username}`);
    onValue(userRef, (snap) => {
        if(snap.exists()) setUserData(snap.val());
    });

    const tasksRef = ref(db, `users/${currentUser.username}/tasks`);
    const unsubscribe = onValue(tasksRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const taskList = Object.keys(data).map(key => ({ id: key, ...data[key] }));
        setTasks(taskList.reverse());
      } else {
        setTasks([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  const handleFinalSubmit = async (task) => {
    // Security Balance Check
    if (parseFloat(userData.balance) < parseFloat(task.orderAmount)) {
        Swal.fire(t('insufficient_balance'), t('deposit_required_msg'), 'error');
        return;
    }

    Swal.fire({
      title: t('submitting_order'),
      allowOutsideClick: false,
      didOpen: () => { Swal.showLoading() }
    });

    try {
      await processTaskLogic(userData, task, true);
      Swal.fire(t('success'), t('order_completed_success'), 'success');
    } catch (err) {
      Swal.fire(t('error'), err.message || t('submission_failed'), 'error');
    }
  };

  const filteredTasks = tasks.filter(t => t.status === activeTab);

  if (loading) return <div className="loader-container">{t('loading_records')}</div>;

  return (
    <div className="record-page">
      <div className="record-tabs">
        <button 
          className={activeTab === 'pending' ? 'active' : ''} 
          onClick={() => setActiveTab('pending')}
        >
          {t('pending')}
        </button>
        <button 
          className={activeTab === 'completed' ? 'active' : ''} 
          onClick={() => setActiveTab('completed')}
        >
          {t('completed')}
        </button>
      </div>

      <div className="record-list">
        {filteredTasks.length === 0 ? (
          <p className="no-data">
            {activeTab === 'pending' ? t('no_pending_orders') : t('no_completed_orders')}
          </p>
        ) : (
          filteredTasks.map((task) => (
            <div key={task.id} className="record-card">
              <div className="card-header">
                <span>ID: {task.id.slice(-6)}</span>
                <span className={`status-text ${task.status}`}>
                  {t(task.status?.toLowerCase()) || task.status?.toUpperCase()}
                </span>
              </div>
              
              <div className="card-body">
                <div className="prod-img-box"><img src={task.img} alt="product" /></div>
                <div className="prod-info">
                  {/* FIX: Yahan exact language detection enable kar di hai */}
                  <p className="prod-title">{t(task.title) || task.title}</p>
                  <p className="prod-amount">{t('amount')}: <strong>${task.orderAmount}</strong></p>
                  <p className="prod-profit">{t('profit')}: <strong className="profit-green">+{task.commEarned}</strong></p>
                </div>
              </div>

              {task.status === 'pending' && (
                <button className="submit-btn-record" onClick={() => handleFinalSubmit(task)}>
                  {t('submit_order')}
                </button>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Record;